import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import User from "../../Utility/Crud/User";

export default class ChipUser extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color =
      this.props.user || this.props.hasSelection ? User.getColor() : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {User.getIcon({ fontSize: "small", sx: { color: iconColor } })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The user name.
   */
  getLabel() {
    if (this.props.user) {
      return User.getDisplayName(this.props.user);
    } else {
      return this.props.nullLabel || "None";
    }
  }
}
